import { Box, Divider, Grid, Typography } from '@mui/material'
import React from 'react'
import { Control } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { FeesForm } from '../property-delayed-fees-dialog'
import { ControlledMuiDateField } from 'components/general/forms/rhf/controlled-mui-date'
import dayjs from 'dayjs'

type PropertyDelayedFeesDialogHeaderProps = {
    totalFees: number
    control: Control<FeesForm>
    from?: Date
}

export const PropertyDelayedFeesDialogHeader: React.FC<PropertyDelayedFeesDialogHeaderProps> = ({
    control,
    totalFees,
    from,
}) => {
    const { t } = useTranslation()

    if (!from) return null

    const dayjsFrom = dayjs(from)

    return (
        <>
            <Grid container columnSpacing={2} mt={0.5} maxWidth={300}>
                <Grid item xs={8}>
                    <Typography variant="body2" component="i">
                        {t('TOTAL_DELAYED_FEES', 'Total delayed interest fees')}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography variant="body2" fontWeight={700} component="span">
                        {`${Intl.NumberFormat('no-NO').format(totalFees)} kr`}
                    </Typography>
                </Grid>
            </Grid>

            <Box maxWidth={120} mt={2.5}>
                <Grid item xs={6}>
                    <ControlledMuiDateField
                        control={control}
                        name="endDate"
                        fullWidth
                        inputProps={{
                            variant: 'standard',
                            placeholder: t('TEXT_DATE_TO', 'Til'),
                            size: 'small',
                            autoFocus: true,
                            sx: {
                                fontSize: 12,
                                '& .MuiInput-input': {
                                    cursor: 'default',
                                },
                            },
                        }}
                        sx={{ cursor: 'default' }}
                        format="DD.MM.YYYY"
                        label={t('TEXT_DATE_TO', 'Til')}
                        shouldDisableDate={(date) => {
                            if (!from) return false

                            const diff = date.diff(dayjsFrom)

                            return diff <= 0
                        }}
                        slotProps={{ field: { readOnly: true } }}
                    />
                </Grid>
            </Box>

            <Divider sx={{ my: 2.5 }} />
        </>
    )
}
